<template>
  <v-content class='home-page'>
    <v-container text-xs-center class="white--text">
      <v-layout row wrap>
        <v-flex xs12 class="mt-4 mb-2"><img src="/static/2dSearch.png"></v-flex>
        <v-flex xs12 class="home-page-title mt-4" bold>Think outside the search box</v-flex>
        <v-flex xs8 offset-xs2 class="title mt-2 mb-5" bold>
          <div class="mb-3">2Dsearch is a radical alternative to conventional 'advanced search'.</div>
          <div class="mb-3">Instead of entering Boolean strings into one-dimensional search boxes, queries are formulated by combining objects on a two-dimensional canvas.</div>
          <div class="mb-3">This eliminates syntax errors, makes the query semantics more transparent, and offers a more effective way to optimize, save and share search strategies.</div>
        </v-flex>
      </v-layout>
      <v-flex xs8 offset-xs2>
        <v-layout row justify-space-around>
          <v-btn large @click="handleGetStartedClick">GET STARTED</v-btn>
          <v-btn large @click="handleAboutClick">ABOUT</v-btn>
          <v-btn large @click="handleRequestDemoClick">REQUEST DEMO</v-btn>
        </v-layout>
      </v-flex>
    </v-container>
  </v-content>
</template>

<script>
import { aboutUrl, requestDemoUrl } from '@/utils/constants'

export default {
  name: 'Home',
  props: ['redirect'],
  methods: {
    handleGetStartedClick () {
      // NOTE: 'Starter Query' page has been replaced by 'Home', this needs updating for link to work on this page
      this.$router.push({name: 'Starter Query'})
    },
    handleAboutClick () {
      window.location = aboutUrl
    },
    handleRequestDemoClick () {
      window.open(requestDemoUrl, '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.home-page {
  height: 100%;
  background: url("/static/bg.jpg") no-repeat center center fixed;
  background-size: auto;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  font-family: 'Roboto-Medium', Helvetica, Arial, sans-serif
}
.home-page-title {
  font-size: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue